import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { FormInput } from "../../components/atoms/form/text/FormInput";
import { FormPhoneNumberInput } from "../../components/atoms/form/text/FormPhoneNumberInput";

export const OnboardingFormStep3EmergencyContact = ({
  onboardingSettings,
}: {
  onboardingSettings: ClubOnboardingSettingsDTO;
}) => {
  const { t } = useTranslation();
  return (
    <motion.div
      className="flex w-full max-w-lg flex-col gap-3"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <div className="dark:text-gray-0 font-semibold text-gray-950">
        {t("pages.onboarding.emergencyContactDetails")}
      </div>
      <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-gray-900">
        {onboardingSettings.emergencyContactSetting !== "DISABLED" && (
          <>
            <FormInput
              name="emergencyContactName"
              label={t("pages.onboarding.emergencyContactNameNew")}
              isRequired={
                onboardingSettings.emergencyContactSetting === "REQUIRED"
              }
              placeholder={t("pages.onboarding.emergencyContactNameNew")}
            />
            <FormPhoneNumberInput
              name="emergencyContact"
              label={t("pages.onboarding.emergencyContact")}
              isRequired={
                onboardingSettings.emergencyContactSetting === "REQUIRED"
              }
              placeholder={t("pages.onboarding.emergencyContact")}
            />
          </>
        )}
      </div>
    </motion.div>
  );
};
